import Title from "../components/ui/Title";
import Button from "../components/ui/Button";
import WorldData from "../data/WorldData";
import ReactHtmlParser from 'react-html-parser';
import '../styles/pages/world.scss';
import { useState } from "react";

const World = () => {
    const [place, setPlace] = useState(0)
    const changePlace = (index) => {
        setPlace(index)
    }

    return (
        <div className="page-container">
            <Title
                text="World"
                size="full"
            />
            <div className="line-container">
                <WorldContent
                    index={place}
                />
                <WorldList 
                    changePlace={changePlace}
                />
            </div>
        </div>
    )

}

const WorldList = ({changePlace}) => (
    <ul className="world-list">
        {
            WorldData.map((place, index) => (
                <li>
                    <Button text={place.title} type="solid" onClick={()=>{
                        changePlace(index)
                    }}/>
                </li>
            ))
        }
    </ul>
)

const WorldContent = ({index}) => (
    <div className="world-contents">
        <div className="world-left">

            <h1 className="world-title">
                { WorldData[index]["title"] }
            </h1>
            <img src={`${process.env.PUBLIC_URL}/img/world/${ WorldData[index]["image"] }.webp`} alt={ WorldData[index]["title"] } />
        </div>
        <div className="world-right">
            { ReactHtmlParser(WorldData[index]["desc"]) }
        </div>
    </div>
)

export default World